<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
            <d-col col sm="6" class="text-left text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Użytkownicy</span>
        <h3 class="page-title">
          <template v-if="isEdit">
            <template v-if="data.id !== currentUserID">Edycja użytkownika</template>
            <template v-if="data.id === currentUserID">Twoje konto</template>
          </template>
          <template v-else>Dodawanie użytkownika</template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="primary"
          outline
          @click.prevent="$router.push('/admin/users')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          theme="success"
          @click.prevent="validateForm">
          <i class="material-icons">done</i>
          Zapisz zmiany
        </d-button>
        <d-button
          v-if="data.id === currentUserID"
          theme="danger"
          outline
          class="ml-1"
          @click.prevent="$router.push('/logout')">
          Wyloguj się
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-card-body>
          <validation-observer ref="user-form" tag="form">
            <div class="form-group">
              <label for="name">
                Imię:
              </label>

              <validation-provider
                rules="required"
                name="name"
                v-model="data.name"
                v-slot="{ errors }">
                <d-input
                  :state="errors.length ? 'invalid' : null"
                  v-model="data.name" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>

            <div class="form-group">
              <label for="surname">
                Nazwisko:
              </label>

              <validation-provider
                rules="required"
                name="surname"
                v-model="data.surname"
                v-slot="{ errors }">
                <d-input
                  :state="errors.length ? 'invalid' : null"
                  v-model="data.surname" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>

            <div class="form-group">
              <label for="email">
                E-mail:
              </label>

              <validation-provider
                rules="required|email"
                name="email"
                v-model="data.email"
                v-slot="{ errors }">
                <d-input
                  :state="errors.length ? 'invalid' : null"
                  type="email"
                  v-model="data.email" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>

            <div class="form-group">
              <label for="email">
                Hasło:
              </label>

              <validation-provider
                :rules="isEdit ? 'min:8' : 'required|min:8'"
                name="password"
                v-model="data.password"
                v-slot="{ errors }">
                <d-input
                  type="password"
                  :state="errors.length ? 'invalid' : null"
                  v-model="data.password" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>

            <div class="form-group">
              <label for="email">
                Powtórz hasło:
              </label>

              <validation-provider
                :rules="isEdit ? 'min:8|password:password' : 'required|min:8|password:password'"
                name="password-confirmation"
                v-model="data.passwordConfirmation"
                v-slot="{ errors }">
                <d-input
                  type="password"
                  :state="errors.length ? 'invalid' : null"
                  v-model="data.passwordConfirmation" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </validation-observer>

          <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
            Trwa ładowanie danych&hellip;
          </div>

          <d-alert
            v-if="loadError"
            show
            theme="warning">
            Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
          </d-alert>
        </d-card-body>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import { mapGetters } from 'vuex';

export default {
  name: 'user-form',
  computed: {
    ...mapGetters('user', [
      'currentUserID'
    ]),
    allDataLoaded () {
      return this.loaded;
    },
    isEdit () {
      return !!this.$route.params.id;
    }
  },
  data() {
    return {
      data: {
        id: 0,
        name: '',
        surname: '',
        email: '',
        type: 'admin',
        password: '',
        passwordConfirmation: ''
      },
      loaded: false,
      loadError: false
    };
  },
  mounted () {
    if (this.isEdit) {
      this.loadItemData();
    } else {
      this.loaded = true;
    }
  },
  methods: {
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/system/users/item/',
        instanceFields: ['id', 'name', 'surname', 'email', 'type'],
        loadedKey: 'loaded'
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['user-form'], this.submitForm);
    },
    submitForm () {
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = this.isEdit ? '/system/users/update/' + this.id : '/system/users/store';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano użytkownika',
        successText: 'Wybrany użytkownik został zapisany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja użytkownika nie powiodła się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/admin/users')
        }
      });
    },
    prepareFormDataToSend () {
      let formDataToSend = {
        name: this.data.name,
        surname: this.data.surname,
        email: this.data.email,
        type: this.data.type
      };

      if (this.data.password !== '' && this.data.passwordConfirmation !== '') {
        formDataToSend.password = this.data.password;
      }

      return formDataToSend;
    }
  }
};
</script>
